// need to disable ts lint because sometimes it thinks an enum variable is not used

import { PortalTranslationKeys } from './portal-translation-keys.enum';
import { DynamicTranslationKeys } from './dynamic-translation-keys.enum';

export const TranslationKeys = {
  ...PortalTranslationKeys,
  ...DynamicTranslationKeys,
};

export type TranslationKeys = PortalTranslationKeys | DynamicTranslationKeys;
